import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, tap} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class TechnicalPopService {
  private tooltipMap = new Map<string, string>();
  private initialized = false;

  constructor(private http: HttpClient) {
  }

  loadTooltipData(): Observable<void> {
    if (this.initialized) {
      return of();
    }

    return this.http.get<{ technicalId: string; cages: any }[]>(environment.baseUrlWs + '/api/technical-pops-tooltip')
      .pipe(
        tap(pops => {
          pops.forEach(pop => this.tooltipMap.set(pop.technicalId, pop.cages));
          this.initialized = true;
        }),
        map(() => void 0),
        catchError(() => {
          return of(); // Don’t crash app
        })
      );
  }

  getCageTooltip(popName: string): string | undefined {
    const cageName = this.tooltipMap.get(popName);
    if (cageName) {
      if (cageName.length > 1) {
        return 'Cages names: ' + cageName;
      }
      return 'Cage name: ' + cageName;
    }
    return;
  }

  getCageName(popName: string): string | undefined {
    return this.tooltipMap.get(popName);
  }
}
